/* eslint-disable react/prefer-stateless-function */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import FilterLayout from './FilterLayout';
import RadioFilter from './RadioFilter';
import CheckboxFilter from './CheckboxFilter';
import GroupedCheckboxFilter from './GroupedCheckboxFilter';
import CollapsibleCheckboxFilter from './CollapsibleCheckboxFilter';

class CommonFilters extends Component {
    adminExperimentFilter(experimentFilter) {
        if (!experimentFilter) return null;
        return (
            <FilterLayout title={experimentFilter.title}>
                <RadioFilter
                    filter={experimentFilter}
                    options={experimentFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    relationshipFilter(relationshipFilter) {
        if (!relationshipFilter) return null;
        return (
            <FilterLayout title={relationshipFilter.title}>
                <CheckboxFilter
                    filter={relationshipFilter}
                    options={relationshipFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    workHistoryFilter(workHistoryFilter) {
        if (!workHistoryFilter) return null;
        return (
            <FilterLayout title={workHistoryFilter.title}>
                <RadioFilter
                    filter={workHistoryFilter}
                    options={workHistoryFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    lastActivityFilter(lastActivityFilter) {
        if (!lastActivityFilter) return null;
        return (
            <FilterLayout title={lastActivityFilter.title}>
                <RadioFilter
                    filter={lastActivityFilter}
                    options={lastActivityFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    contactsFilter(contactsFilter) {
        if (!contactsFilter) return null;
        return (
            <FilterLayout title={contactsFilter.title}>
                <RadioFilter
                    filter={contactsFilter}
                    options={contactsFilter.options}
                    onChange={this.props.onChange}
                />
            </FilterLayout>
        );
    }

    render() {
        const { filterStore } = this.props;
        const experimentFilter = filterStore.getFilterByName('experiment');
        const categoryFilter = filterStore.getFilterByName('categories');
        const industryFilter = filterStore.getFilterByName('industries');
        const relationshipFilter = filterStore.getFilterByName('relationship');
        const lastActivityFilter = filterStore.getFilterByName('last-activity');
        const levelFilter = filterStore.getFilterByName('designer-level');
        const languagesFilter = filterStore.getFilterByName('languages');
        const workHistoryFilter = filterStore.getFilterByName('work-history');
        const contactsFilter = filterStore.getFilterByName('contacts');

        return (
            <div>
                {this.adminExperimentFilter(experimentFilter)}
                <FilterLayout title={categoryFilter.title}>
                    <GroupedCheckboxFilter filter={categoryFilter} onChange={this.props.onChange} />
                </FilterLayout>
                <FilterLayout title={industryFilter.title}>
                    <CollapsibleCheckboxFilter
                        filter={industryFilter}
                        onChange={this.props.onChange}
                    />
                </FilterLayout>
                {this.relationshipFilter(relationshipFilter)}
                {this.workHistoryFilter(workHistoryFilter)}
                {this.lastActivityFilter(lastActivityFilter)}
                <FilterLayout title={levelFilter.title}>
                    <CheckboxFilter
                        filter={levelFilter}
                        options={levelFilter.options}
                        onChange={this.props.onChange}
                    />
                </FilterLayout>
                <FilterLayout title={languagesFilter.title}>
                    <CheckboxFilter
                        filter={languagesFilter}
                        options={languagesFilter.options}
                        onChange={this.props.onChange}
                    />
                </FilterLayout>
                {this.contactsFilter(contactsFilter)}
            </div>
        );
    }
}

CommonFilters.propTypes = {
    filterStore: PropTypes.shape({
        getFilterByName: PropTypes.func.isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default inject('filterStore')(observer(CommonFilters));



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/CommonFilters.jsx